<div class="flex flex-col h-full" *ngIf="summaries; else noSummaries">
	<div class="flex justify-between items-center pb-4 border-b border-gray-200">
		<div class="flex gap-0.5">
			<h2 class="h2">{{ docketTitle }}</h2>
		</div>
		<div class="flex gap-4 items-center">
			<!-- <p class="text-xs text-gray-500">{{currentStep}} of {{numSteps}}</p> -->
			<ui-button
				icon="x"
				preset="ICON_DEFAULT"
				(click)="closeModal()"
				[testHook]="testHooks.Button"
			></ui-button>
		</div>
	</div>

	<div class="flex flex-1 overflow-y-auto py-4 gap-6">
		<div class="pb-12 flex flex-col md:w-2/3">
			<div class="flex justify-between">
				<h3 class="my-0 py-0 h3">Docket Summary</h3>
				<ui-button
					[style]="'outline'"
					color="gray"
					label="Print Docket"
					icon="printer"
					(click)="printDocket()"
					[testHook]="testHooks.PrintDocketButton"
				></ui-button>
			</div>
			<app-docket-summary-charge-table
				id="docket-summary"
				[summary]="summaries"
				class="py-4"
			></app-docket-summary-charge-table>
		</div>
		<div class="flex-1 md:w-1/3">
			<app-docket-sync [summaries]="summaries"></app-docket-sync>
		</div>
	</div>

	<div class="flex justify-end space-x-4 pt-4 border-t border-gray-200">
		<ui-button
			[style]="'outline'"
			label="Close"
			color="gray"
			size="md"
			(click)="closeModal()"
			[testHook]="testHooks.CloseButton"
		>
		</ui-button>
	</div>
</div>

<ng-template #noSummaries>
	<div class="flex flex-1 justify-center items-center flex-col h-full">
		<div *ngIf="error && !loading">
			{{ error }}
		</div>
		<div *ngIf="noDocket" class="flex justify-center items-center pb-20">
			<ui-empty
				title="Looks like you don't have a docket yet"
				description="Please create a docket to view the summary"
				icon="file-off"
			>
				<ui-button
					label="Create Docket"
					color="primary"
					(click)="createDocket()"
				></ui-button>
			</ui-empty>
		</div>
		<div *ngIf="loading" class="flex justify-center items-center">
			<app-icon
				[icon]="ICON.LOADING"
				[spin]="true"
				class="mr-5"
				[testHook]="testHooks.LoadingIcon"
			></app-icon>
			Loading docket summary
		</div>
	</div>
</ng-template>
